import React, { useContext } from 'react';
import logo from '@assets/logo.svg';
import test from '@assets/TestEnvironment.png';
import './Navbar.less';
import { Avatar, Dropdown, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { AuthContext } from 'auth/context';

const Navbar: React.FC = () => {
  const { isAuthenticated, logout, user } = useContext(AuthContext);

  const menu = (
    <Menu className="Navbar-menu">
      <Menu.Item>
        <span className="font-light">{user?.email}</span>
      </Menu.Item>
      <Menu.Item onClick={logout}>
        <span className="font-bold">Log out</span>
      </Menu.Item>
    </Menu>
  );

  const isTestEnvironment = window.location.hostname.endsWith(
    'testrequisitionforms.idexx.com'
  );

  return (
    <div className="Navbar-body">
      <div className="container">
        <Link to="/">
          <img src={logo} alt="IDEXX logo" className="Navbar-logo" />
        </Link>
        {isTestEnvironment && (
          <img src={test} alt="Test environment" className="Navbar-logo" />
        )}
        {isAuthenticated && (
          <Dropdown overlay={menu}>
            <Avatar className="bg-primary cursor-pointer" shape="square">
              {user?.email.slice(0, 1)}
            </Avatar>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default Navbar;
